import React, { ComponentProps, forwardRef } from 'react';
import { TextArea as CarbonTextArea } from '@carbon/react';

export type TextAreaProps = ComponentProps<typeof CarbonTextArea>;

export const TextArea = forwardRef<HTMLTextAreaElement, TextAreaProps>(
  ({ children, ...props }, ref) => (
    <CarbonTextArea ref={ref} {...props}>
      {children}
    </CarbonTextArea>
  )
);

TextArea.displayName = 'TextArea';
